import { GlobalData } from "../Common/GlobalData";
import { TemplateHelpers } from "../Common/KendoHelpers";

export class ETFsHistory {
    private static readonly NUM_DAYS = '#numDays';
    private static readonly UPDATE_NUM_DAYS = '#updateNumDays';
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(ETFsHistory.NUM_DAYS).kendoNumericTextBox({
            value: 25,
            format: '0',
            decimals: 0,
            min: 1
        });

        $(ETFsHistory.UPDATE_NUM_DAYS).on('click', () => {
            const grid = $(ETFsHistory.GRID).data('kendoGrid')!;
            const dataSource = grid.dataSource;
            const numDays = this.getNumDays();
            dataSource.pageSize(numDays);
        });

        $(ETFsHistory.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_GENERAL_REPORTS_ETFS_HISTORY,
                },
                pageSize: this.getNumDays(),
                serverPaging: true,
                serverSorting: true,
            },

            height: 915,
            groupable: false,
            pageable: false,
            sortable: true,
            columns: [
                {
                    title: " ",
                    width: '.25%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", bgcolor: "LightGray" },
                },
                {
                    field: "tradingDate",
                    title: "Trading<br />Date",
                    width: '25%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('tradingDate')),
                },
                {
                    title: 'Day',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getTradingDayTemplate('tradingDate')),
                },
                {
                    title: " ",
                    width: '.25%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", bgcolor:"LightGray" },
                },
                {
                    field: 'numberFullOverbought',
                    title: "Full<br />Overbought",
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'numberFullOversold',
                    title: "Full<br />Oversold",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    title: " ",
                    width: '.25%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", bgcolor: "LightGray" },
                },
                {
                    field: 'numberSlowOverbought',
                    title: "Slow<br />Overbought",
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'numberSlowOversold',
                    title: "Slow<br />Oversold",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    title: " ",
                    width: '.25%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", bgcolor: "LightGray" },
                },
                {
                    field: 'numberFastOverbought',
                    title: "Fast<br />Overbought",
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'numberFastOversold',
                    title: "Fast<br />Oversold",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    title: " ",
                    width: '.5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", bgcolor: "LightGray" },
                },
            ]
        });
    }

    private getNumDays() {
        return parseInt($(ETFsHistory.NUM_DAYS).val()!.toString());
    }
}
